import {NotificationService} from "../../services/NotificationService";
import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {EmployeeLocationHistoryService} from "../../services/EmployeeLocationHistoryService";
import {ReportAssetsModelBase} from "./ReportAssetsModelBase";

export class ReportEmployeeLocationHistoryModel {
    static $inject = ['$window','$q','FileSaver','Blob','EmployeeLocationHistoryService','CustomFieldNameService','NotificationService'];
    errorMessage: string = "";
    firstName: string = "";
    lastName: string = "";
    email: string = "";
    location: string = "";
    totalCount: number = 0;
    constructor(public $window:Window,
                public $q:ng.IQService,
                public fileSaver:any,
                public blob:any,
                public employeeLocationHistoryService:EmployeeLocationHistoryService,
                public cfnService:CustomFieldNameService,
                public notifyService:NotificationService) {
        this.getCount();
    }
    getReportName():String{
        return "Employee Location History Report";
    }
    getHeader():string[]{
        return ["ID", "Location Name","Asset Name", "Transaction Time", "Asset ID"];
    }
    getMyReport():ng.IPromise<any>{

        return this.employeeLocationHistoryService.getReport(false, this.firstName, this.lastName, this.email, this.location).then((data) => {
            var blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            this.fileSaver.saveAs(blob, 'employeeLocationHistory.xlsx');
        })
        .catch((exc)=>{
            this.notifyService.notify("getReport err:"+exc);
        });
        return this.$q.when();
    }

    getCount():ng.IPromise<any>{
        //alert(this.location);
        return this.employeeLocationHistoryService.getReportCount(false, this.firstName, this.lastName, this.email, this.location)
            .then((data)=>{
                this.totalCount = data;
            }).catch((exc)=>{
                this.notifyService.notify("Exception in getCount-"+exc);
            });
    }

}

